import React from "react";
import PropTypes from "prop-types";
import { formatRemaining } from "./sessionState";
import "./sessionWarningBanner.scss";

const SessionWarningBanner = ({ remainingMs, onContinue }) => (
    <div className="rdc-session-banner" role="status">
        <p className="rdc-session-banner__text">
            Your session will lock in{" "}
            <span className="rdc-session-banner__count" aria-live="off">{formatRemaining(remainingMs)}</span>
            {" "}due to inactivity. Continue working to stay signed in.
        </p>
        <button type="button" className="btn btn-primary" onClick={onContinue}>
            Continue session
        </button>
    </div>
);

SessionWarningBanner.propTypes = {
    remainingMs: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired,
};

export default SessionWarningBanner;
